module.exports = __webpack_public_path__ + "img/thumb_8.ade08c7b.jpg";